import React from 'react'

const Step = ({ step, heading, description }) => {
  return (
    <tbody>
      <tr>
        <td className='w-[40%] align-top'>
          <img className='w-[78px] h-[72px] md:w-[91px] md:h-[84px] lg:w-[104px] lg:h-[96px] rounded ml-auto mr-8 mb-8 md:mb-12 lg:mb-20' src={require(`../../assets/icon-step${step}.png`)} alt={`step-${step}`} />
        </td>
        <td className='w-[60%] text-left align-top'>
          <h5 className='font-bold text-xs md:text-sm lg:text-base text-[#71717A] tracking-widest'>STEP {step}</h5>
          <h3 className='font-bold text-lg md:text-xl lg:text-2xl'>{heading}</h3>
          <p className='text-sm text-[#71717A] md:text-lg lg:text-xl mb-8 md:mb-12 lg:mb-20'>{description}</p>
        </td>
      </tr>
    </tbody>
  )
}

export default Step